var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05703 11.0573C7.57773 10.5366 8.42195 10.5366 8.94265 11.0573L15.9998 18.1145L23.057 11.0573C23.5777 10.5366 24.4219 10.5366 24.9426 11.0573C25.4633 11.578 25.4633 12.4222 24.9426 12.9429L16.9426 20.9429C16.4219 21.4636 15.5777 21.4636 15.057 20.9429L7.05703 12.9429C6.53633 12.4222 6.53633 11.578 7.05703 11.0573Z",
    fill: "#9F9978"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.3d05742666b1a38065ec033e406174c6.svg";
export { ForwardRef as ReactComponent };